// Using 3x2 standard flag ratio for full flag display
import US from 'country-flag-icons/react/3x2/US'
import ID from 'country-flag-icons/react/3x2/ID'

export const locales = ['en', 'id'] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'en'

export const localeNames: Record<Locale, string> = {
  en: 'English',
  id: 'Bahasa Indonesia',
}

export const localeCodes: Record<Locale, string> = {
  en: 'EN',
  id: 'ID',
}

// Professional SVG flags from country-flag-icons
export function FlagIcon({ locale, className }: { locale: Locale; className?: string }) {
  const flags: Record<Locale, React.ComponentType<{ title?: string; className?: string }>> = {
    en: US,
    id: ID,
  }

  const FlagComponent = flags[locale]
  return <FlagComponent title={localeNames[locale]} className={className} />
}
